export function stripReplyFallback(body: string): string {
  if (!body.startsWith('> ')) return body
  const lines = body.split('\n')
  let i = 0
  while (i < lines.length && lines[i]!.startsWith('> ')) i++
  if (i < lines.length && lines[i] === '') i++
  return lines.slice(i).join('\n')
}
